import Blank from "@/layouts/blank.vue";


import NewTripDetails from "@/pages/admin/trip/NewTripDetails.vue";
import TripSchedulingListNew from "@/pages/admin/trip/TripSchedulingListNew.vue";

const tripRoutes = [
  {
    path: "trip",
    name: "app-admin-trip",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/trip/new-list",
      },

      {
        path: "new-list",
        name: "app-admin-trip-new-list",
        component: TripSchedulingListNew,
      },
      {
        path: "details",
        name: "app-admin-trip-details",
        component: Blank,
        children: [
          {
            path: "/",
            redirect: "/app/admin/trip/new-list",
          },

          {
            path: ":id",
            name: "app-admin-trip-details-id",
            component: NewTripDetails,
          },
        ],
      },
    ],
  },
];

export default tripRoutes;
